import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import { Overlay } from "./auth-service-tools282.js";
import { Transition } from "./auth-service-tools276.js";
import { useModalBaseContext } from "./auth-service-tools286.js";
import { useModalTransition } from "./auth-service-tools295.js";
const ModalBaseOverlay = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onClick,
    transitionProps,
    style,
    ...others
  } = _ref;
  const ctx = useModalBaseContext();
  const transition = useModalTransition(transitionProps);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Transition, {
    mounted: ctx.opened,
    ...transition,
    transition: "fade",
    children: transitionStyles => /* @__PURE__ */jsxRuntimeExports.jsx(Overlay, {
      ref,
      fixed: true,
      style: [style, transitionStyles],
      zIndex: ctx.zIndex,
      unstyled: ctx.unstyled,
      onClick: event => {
        onClick == null ? void 0 : onClick(event);
        ctx.closeOnClickOutside && ctx.onClose();
      },
      ...others
    })
  });
});
ModalBaseOverlay.displayName = "@mantine/core/ModalBaseOverlay";
export { ModalBaseOverlay };